/* MonitorButtons — the "Live Cleanliness Monitor" + "Live Labor Cost
   Monitor" button pair, shown directly above the Project Management ·
   PACER section on the dashboard. */
import { useState } from 'react';
import { Sparkles, DollarSign } from 'lucide-react';
import CleanlinessMonitorDialog from './CleanlinessMonitorDialog';
import LaborCostMonitorDialog from './LaborCostMonitorDialog';

export default function MonitorButtons({ slides, settings }) {
  const [cleanOpen, setCleanOpen] = useState(false);
  const [laborOpen, setLaborOpen] = useState(false);

  return (
    <section className="mt-3" data-testid="monitor-buttons">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          data-testid="open-cleanliness-monitor"
          onClick={() => setCleanOpen(true)}
          className="inline-flex items-center gap-2 px-7 py-3 rounded-full text-white font-bold text-sm tracking-wide transition-all hover:-translate-y-0.5"
          style={{ fontFamily: 'Manrope', background: 'linear-gradient(135deg, #0F766E 0%, #115E59 55%, #0A1A2F 100%)', border: '1px solid rgba(163,212,212,0.35)' }}
        >
          <Sparkles className="w-4 h-4" /> Live Cleanliness Monitor
        </button>
        <button
          type="button"
          data-testid="open-labor-cost-monitor"
          onClick={() => setLaborOpen(true)}
          className="inline-flex items-center gap-2 px-7 py-3 rounded-full text-white font-bold text-sm tracking-wide transition-all hover:-translate-y-0.5"
          style={{ fontFamily: 'Manrope', background: 'linear-gradient(135deg, #1F4FBE 0%, #003DA5 55%, #0A1A2F 100%)', border: '1px solid rgba(163,192,235,0.35)' }}
        >
          <DollarSign className="w-4 h-4" /> Live Labor Cost Monitor
        </button>
      </div>

      <CleanlinessMonitorDialog open={cleanOpen} onClose={() => setCleanOpen(false)} slides={slides} settings={settings} />
      <LaborCostMonitorDialog open={laborOpen} onClose={() => setLaborOpen(false)} settings={settings} />
    </section>
  );
}
